<template>
    <div>
        <div class="report-detail flex-wrap-sm">
            <el-button @click="drawer = true" class="d-md-none select-button" size="mini" type="primary" plain>filter
            </el-button>
            <el-drawer
                    :visible.sync="drawer"
                    :with-header="false"
                    size="164px"
                    direction="ltr">
                <nav-list class="left-nav" ref="navList" @selectItem="selectItem" :value="selectValue"></nav-list>
            </el-drawer>
            <nav-list class="left-nav d-none d-md-block" @selectItem="selectItem" ref="navList"
                      :value="selectValue"></nav-list>
            <div class="search-detail max-width-sm" v-loading="loading">
                <search-result class="search-head" @search="search" @sortList="sortList" :value="resultValue"
                               ref="searchResult"></search-result>
                <div v-if="allTabData.title" class="tab-chart" :class="{'tab-chart-none':!tabType}">
                    <div class="tab-chart-top">
                        <div class="tab-data-title">{{allTabData.title}}</div>
                        <div class="tab-chart-type" @click="tabType=!tabType">{{tabType?'&lt;&lt;&lt;fewer':'unfold>>>'}}
                        </div>
                    </div>
                    <!--                    <classify-tabs :value="tabsValue" class="tabs-classify-wrap"-->
                    <!--                                   @changeTab="changeSelectType"></classify-tabs>-->
                    <the-data-card :value="dataCardValue" v-if="dataCardValue && tabType"></the-data-card>
                    <!--          <the-line-chart :value="areaBasicValue"-->
                    <!--                          class="common-tab-container"-->
                    <!--                          v-if="selectTabType === 'line'"></the-line-chart>-->
                    <!--                    <the-bar-chart :value="areaBasicValue"-->
                    <!--                                   class="common-tab-container"-->
                    <!--                                   v-if="selectTabType === 'bar'"></the-bar-chart>-->
                </div>
                <item-detail class="search-item"
                             :is-keep="isKeep"
                             :value="itemDetailValue"
                             :key="sortField + '-' + selectType"
                             @gotoDetail="gotoSearchDetail"
                             :resultValue="resultValue"
                             @jumpList="requestAllData"
                             @searchItem="changeCommon"
                ></item-detail>
            </div>
            <div class="right-content max-width-sm d-md-none d-lg-block nano">
                <div class="right-wrap nano-content">
                    <div class="graph-wrap" v-if="graphTitle && this.graphValue.graph">
                        <div class="graph-head">
                            <div class="graph-left">
                                <div class="common-line"></div>
                                <div class="title">{{graphTitle}}</div>
                            </div>
                            <!--                            <span class="change-text" @click="gotoCountry">进入专区 ></span>-->
                        </div>
                        <!--                        <normal-graph :value="graphValue"-->
                        <!--                                      :is-center="true"-->
                        <!--                                      @changeGraph="gotoCountry"-->
                        <!--                                      ref="graph"-->
                        <!--                                      @doubleClick="addNode"></normal-graph>-->
                    </div>
                    <div class="common-card-wrap" :class="{'mt-0': !graphTitle}" v-if="commonCard.length">
                        <!--            <div class="nano-content">-->
                        <common-card class="important-card"
                                     v-for="(item, index) in commonCard"
                                     :key="index"
                                     :value="getValue(item)"
                                     @change="changeCommon"
                        ></common-card>
                        <!--            </div>-->
                    </div>
                    <hot-list :value="heatRankingValue"
                              class="list-wrap"
                              @changeList="changeList"
                              @click="changeCommon"
                    ></hot-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavList from './components/navList'
import SearchResult from './components/searchResult'
import ItemDetail from './components/itemDetail'
import NormalGraph from '../components/normalGraph'
import CommonCard from './components/commonCard'
// import config from '@/common/config'
import searchMap from '../utils/searchMap'
import MixinUpdateData from '@/views/TheHome/mixins/updateData'
import searchHighlightMixin from '@/views/search/mixin/searchHighlight'
import * as _ from 'lodash'
import MixinDataTime from '@/views/TheHome/mixins/dateTime'
import MixinsHandleGraph from '@/views/TheHome/mixins/handleGraph'
import ClassifyTabs from '../components/classifyTabs'
import TheDataCard from './components/theDataCard'
import TheBarChart from './components/theBarChart'
import TheLineChart from './components/theLineChart'
import HotList from './components/hotList'
import {
  simplekw,
  importantCity,
  importantCountry, importantFirm, importantIdustry,
  importantOrganization, importantPeople,
  othersHotWords,
  searchSchema, baseUrl
} from 'common/js/http/pdBase'

export default {
  name: 'reportDetail',
  components: {
    HotList,
    TheLineChart,
    TheBarChart,
    TheDataCard, ClassifyTabs, CommonCard, NormalGraph, ItemDetail, SearchResult, NavList
  },
  mixins: [MixinUpdateData, searchHighlightMixin, MixinDataTime, MixinsHandleGraph],
  data () {
    return {
      searchToken: '',
      tabType: true,
      drawer: false,
      colorOption: '#208EFF',
      heatRankingValue: {
        content: [],
        page: 1,
        size: 15,
        total: 0
      }, // 排行榜
      colorStops: [
        {offset: 0, color: '#fff'},
        {offset: 1, color: '#208EFF'}
      ],
      allTabData: {
        title: '',
        tabArr: []
      },
      areaBasicValue: null,
      dataCardValue: {},
      selectTabType: '',
      tabsValues: [],
      // echarts: ['Graph'],
      id: 0,
      entityName: '',
      entityType: '',
      className: '',
      graphRouterName: '',
      entityMap: {
        '国家': { // 国家
          title: '国家专题挖掘', // 国家专题挖掘
          cardArr: [ // 关联重要人物,关联重要组织机构,关联主要城市
            'ImportantPeople',
            'ImportantOrganization',
            'ImportantCity'
          ],
          extraData: {
            timeFilter: ''
          },
          value: 'nationalCityTopics',
          layout: 'static',
          apiSearchNode: '/country/graphExplore',
          apiSearchId: '/country/getEntityId'
        },
        '人物': {
          title: '',
          cardArr: [ // 关联主要国家 关联重要人物
            'ImportantOrganization',
            'ImportantFirm'
          ]
        },
        '企业': {
          title: '企业专题挖掘', // 还没有接口
          cardArr: [ // 关联重要人物 关联行业 关联组织机构
            'ImportantPeople',
            'ImportantOrganization',
            'ImportantIdustry' // 关联行业
          ],
          value: 'enterpriseExpert',
          apiSearchNode: '/product/graphExplore',
          layout: 'radial',
          extraData: {
            reportType: '',
            timeFilter: ''
          },
          apiSearchId: '/product/getEntityId'
        },
        '城市': {
          title: '国家专题挖掘',
          cardArr: [
            'ImportantFirm'
          ],
          extraData: {
            timeFilter: ''
          },
          value: 'nationalCityTopics',
          layout: 'static',
          apiSearchNode: '/country/cityGraphExplore',
          apiSearchId: '/country/getEntityId'
        },
        '研报类型': {
          title: '丝路稿件专题',
          cardArr: [
            'ImportantCountry',
            'ImportantPeople',
            'ImportantOrganization'
          ],
          value: 'excavateTopics',
          apiSearchNode: '/product/singleGraphExplore',
          layout: 'radial',
          extraData: {
            reportType: '',
            timeFilter: ''
          },
          apiSearchId: '/product/getEntityId'
        },
        '组织机构': {
          title: '',
          cardArr: [ // 关联主要国家 关联重要人物
            'ImportantCountry',
            'ImportantPeople'
          ]
        },
        '行业': {
          title: '行业专题挖掘',
          cardArr: [ // 关联主要国家 关联重要人物
            'ImportantFirm'
          ]
        }
      },
      commonCard: [],
      selectType: this.$route.params.type || '',
      keyWord: this.$route.params.keyword || '',
      hightQueryBean: [], // 高级检索
      docTypeList: [],
      isAdvanced: false,
      filters: [],
      sortField: '混合排序', // 排序字段
      sorts: '1', // 排序方式 0 升序 1 降序
      compareMap: {},
      resultValue: {
        keyWord: '',
        result: '',
        rsCount: 10
      },
      ImportantCountryValue: { // 关联国家
        isCircle: false,
        hasSubText: false,
        title: '关联国家',
        contentList: []
      },
      ImportantIdustryValue: { // 关联行业
        isCircle: false,
        hasSubText: false,
        title: '关联行业',
        contentList: []
      },
      ImportantFirmValue: { // 关联企业
        isCircle: false,
        hasSubText: false,
        title: '关联企业',
        contentList: []
      },
      ImportantPeopleValue: { // 重要人物
        isCircle: false,
        hasSubText: false,
        title: '重要人物',
        contentList: []
      },
      ImportantOrganizationValue: { // 重要组织
        isCircle: false,
        hasSubText: false,
        title: '主要组织',
        contentList: []
      },
      ImportantCityValue: { // 重要城市
        isCircle: false,
        hasSubText: false,
        title: '主要城市',
        contentList: []
      },
      itemDetailValue: {
        page: 1,
        size: 10,
        pageCount: 0,
        isDetail: true,
        spaceEndShow: false,
        spaceLoadShow: false,
        content: []
      },
      graphTitle: '',
      graphValue: {
        graph: null,
        haveNoPage: true,
        layout: 'none'
      },
      selectValue: [],
      loading: false,
      routeSearchTime: null,
      isKeep: false
    }
  },
  watch: {
    '$route.params': {
      handler () {
        // debugger
        if (this.$route.name === 'SearchType') {
          if (this.selectType !== this.$route.params.type || this.keyWord !== this.$route.params.keyword) {
            this.isKeep = false
          }
          if (!this.isKeep) {
            this.selectType = this.$route.params.type || ''
            this.keyWord = this.$route.params.keyword || ''
            this.$refs.searchResult.selectType = '混合排序'
            this.sortField = '混合排序'
            this.graphValue.graph = null
            this.clearSelectItem()
            if (this.routeSearchTime) {
              clearTimeout(this.routeSearchTime)
            }
            this.requestAllData()
            this.searchChart()
            this.$nextTick(() => {
              this.requestConcept().then(() => {
                // this.updateEcharts()
              })
            })
          }
        }
      },
      deep: true
    }
  },
  computed: {
    getHeight () {
      const reg = 100 / this.commonCard.length
      return `calc(${reg}% - 10px)`
    },
    tabsValue () {
      const arr = []
      if (this.allTabData.tabArr) {
        _.forEach(this.allTabData.tabArr, (item, index) => {
          const ite = {
            label: item.name,
            value: index.toString(),
            data: item
          }
          arr.push(ite)
        })
      }
      return arr
    },
    isRecovery () {
      return this.$route.params.isRecovery & ~~this.$route.params.isRecovery
    }
  },
  mounted () {
    this.$eventBus.$on('isAdvanced', (value) => {
      // debugger
      this.routeSearchTime = setTimeout(() => {
        this.filters = []
        this.$refs.navList.clearFilter()
        this.requestAllData()
      }, 500)
    })
    this.createdSelectValue()
    this.$nextTick(() => {
      this.searchChart()
      this.requestAllData()
      this.requestConcept().then(() => {
        // this.updateEcharts()
      })
      this.requestHotList()
    })
  },
  activated () {
    this.isKeep = false
  },
  deactivated () {
    this.isKeep = true
  },
  beforeDestroy () {
    this.$eventBus.$off('isAdvanced')
  },
  methods: {
    search (val) { // 搜索结果 仍然搜索触发
      const params = {...this.$route.params}
      params.isRecovery = 0
      this.$router.replace({params})
    },
    searchItem (val) { // 搜索关键词
    },
    gotoRelation (val) { // 相关推荐的跳转
    },
    getValue (val) { // 点击卡片搜索
      const obj = val + 'Value'
      return this[obj]
    },
    changeSelectType (tab, val, vals) { // tab切换
      if (this.allTabData.tabArr[vals].name === 'Basic Information') {
        this.dataCardValue = this.allTabData.tabArr[vals]
        this.selectTabType = ''
      } else {
        this.areaBasicValue.title = this.allTabData.tabArr[vals].name
        this.areaBasicValue.data = this.allTabData.tabArr[vals]
        this.selectTabType = this.areaBasicValue.data.series[0].type
      }
    },
    changeList () {
      if (this.heatRankingValue.page === this.heatRankingValue.pageCount || this.heatRankingValue.page === 5) {
        this.heatRankingValue.page = 1
      } else {
        this.heatRankingValue.page += 1
      }
      this.requestHotList()
    },
    requestHotList(){
      let id='90032'
      // if(process.env.NODE_ENV === 'production'){
      //   id = '420074'
      // }else{
      //   // id = '600061'
      // }
      let _this = this;
      this.$axios.get(`/api/pc/enListHand?id=${id}`, {}).then(function (res) {
        console.log(res.data);
        if(res.data.code == 200){
          let data = res.data.data.map(item=>{
            item.word = item.title;
            return item;
          }).reverse()
          _this.heatRankingValue.content = data
        }
      });
    },
    // 弃用
    requestHotList2 () {
      const data = {
        pageNo: this.heatRankingValue.page,
        pageSize: this.heatRankingValue.size,
        docType: 'Real-time Info'
      }
      othersHotWords(data).then((data) => {
        if (data.errCode === 200) {
          this.heatRankingValue.content = data.data.rsData
          this.heatRankingValue.total = data.data.rsCount
          this.heatRankingValue.pageCount = _.ceil(this.heatRankingValue.total / this.heatRankingValue.size)
        } else {
          this.heatRankingValue.content = []
        }
      })
    },
    // toDo 国建详情暂无确定
    searchChart: function () {
      if (this.keyWord) {
        this.allTabData.title = ''
        this.$pdAxios({
          method: 'post',
          url: `/ensearch/provinceBasicInfo/${this.keyWord}`,
          baseURL: baseUrl
        }).then((data) => {
          if (data.data.errCode === 200 && data.data.data) {
            const _data = data.data.data
            if (_data) {
              this.allTabData.title = 'Province InfoBox'
              for (let key in _data) {
                if (key.indexOf('Gdp') !== -1) {
                  let newKey = key.replace(/Gdp/, 'GDP')
                  _data[newKey] = _data[key]
                  delete _data[key]
                }
              }
              this.dataCardValue = _data
            } else {
              this.dataCardValue = {}
            }
            //   console.log(_data)
            //   this.allTabData.title = _data.question || (_data.page && _data.page.length && this.keyWord)
            //   this.allTabData.tabArr = _data.page.map((item) => {
            //     if (!item.name) {
            //       item.name = 'Basic Information'
            //     }
            //     return item
            //   })
            //   this.areaBasicValue = {
            //     title: _data.page[0].name,
            //     data: _data.page[0]
            //   }
            //   if (this.areaBasicValue.title === 'Basic Information') {
            //     this.selectTabType = ''
            //     this.dataCardValue = _data.page[0]
            //   } else {
            //     this.selectTabType = this.areaBasicValue.data.series[0].type
            //   }
            // } else {
            //   this.allTabData.title = ''
            //   this.allTabData.tabArr = []
          }
        }).catch(() => {
          this.allTabData.title = ''
          // this.allTabData.tabArr = []
          this.dataCardValue = {}
        })
      } else {
        this.allTabData.title = ''
        this.allTabData.tabArr = []
      }
    },
    requestConcept () {
      const data = {
        kw: this.keyWord
      }
      return Promise.resolve()
      // return searchSchema(data).then((data) => {
      //   if (data && data.errCode === 200 && data.data.length) {
      //     const entityArr = data.data
      //     const entityItem = _.find(entityArr, (item) => {
      //       return item.className !== '关键词'
      //     })
      //     if (entityItem) {
      //       this.className = entityItem.className
      //       this.entityName = entityItem.name
      //       this.entityType = entityItem.classId
      //       if (this.entityMap[this.className]) {
      //         const entityObj = this.entityMap[this.className]
      //         if (entityObj.title) {
      //           this.graphValue.layout = entityObj.layout
      //           this.apiSearchNode = entityObj.apiSearchNode
      //           this.apiSearchId = entityObj.apiSearchId
      //           this.extraData = entityObj.extraData
      //           this.graphRouterName = entityObj.value
      //           this.id = entityItem.id
      //         }
      //         const echartArr = _.cloneDeep(entityObj.cardArr)
      //         echartArr.push('Graph')
      //         this.commonCard = this.entityMap[this.className].cardArr
      //         this.echarts = echartArr
      //       } else { // 没有找到对应的id
      //         this.className = ''
      //         this.echarts = []
      //         this.commonCard = []
      //       }
      //     } else { // 没有找到对应的id
      //       this.className = ''
      //       this.echarts = []
      //       this.commonCard = []
      //     }
      //   } else { // 没有找到对应的id
      //     this.className = ''
      //     this.echarts = []
      //     this.commonCard = []
      //   }
      //   this.graphTitle = this.entityMap[this.className] && this.entityMap[this.className].title
      // })
    },
    requestImportantOrganization () {
      importantOrganization(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAB1CAYAAAA7rH1RAAAABHNCSVQICAgIfAhkiAAABE5JREFUeF7t3U1O21AQB/D3nOKEUGREKkoTGqoill30AtyCe7DhFCzgHtyCC3TRJSKpU5JS2iAsipyExq5eClUJIRkmb2wDf0ts0Mwk78fE4/hDaKWUajQa5TiOt6Mo2ozjuGJ+h+3hAlrrpuM4+1rrnWq12tIGNoqig3w+v5bP51Uul3t4VWQMBPr9vup2u+bnyHGcDe37/q7rulvFYhFElgTCMDTAe7perzc9zyujYy3JXndwEAQtXavV4lKpZK8yKg0E2u22Aq5QMwBXCBadKwgLXOAKCwiWxz4XuIICgqXRucAVFBAsjc4FrqCAYGl0LnAFBQRLo3OBKyggWBqdC1xBAcHS6FzgCgoIlkbnAldQQLA0Ohe4ggKCpdG5wBUUECyNzgWuoIBgaXQucAUFBEujc4Gr1K/LUPlfTwYUq2+X1cu5WUEWO6UfReeenJ6pb9/bt1b85nVJLS8t2lEQqpJp3N7Vb1X70lRhpzdy+bMFV71/V1HuzAshnunKZhb37PxCHTdPVT+Kxq4w5zhqpbKkFhfmp5MQyM4crsH0GycquLh80HK9+Tm1Wl1WBjsrW6Zwb4aW2R1wNrN7yNKwywzuqKHFATY5WRl2qeNOGlpc4CwMu1RxqUOLC5z2sEsFlzu0uMhpDbvEcacdWlzgNIZdorg2hxYXOclhlwiu1NDiAic17MRxpYcWFziJYSeGm/TQ4iJLDjsR3LSGFhdYathZx/3RDtRx65S7zlTzzFdnmyeArON++nyYKtC0L/7xw/q0Jf7lW8c1A+xn+9zaG0yy0KvSQrY7N0mMrL+W9c7N+oKTfH/AFdQGLnAFBQRLJ9a5kw7RzGVyc1Ll/818GTmsHY9d/vr7lTv3MJjL8OYk0bjN5iHXfa8DXHTu/QLoXKUUdguCHxHgAteqAAaaVc7bxYALXBwtjO0BDDTBjwhwgWtVAAPNKieOFgYCOHGDs2K0zxUGGs2JFQVcFtvdJPNo0/CNIebE97jN3PXiujO3Qsy/YrnvMambQHNT3fA/D+n1rtSk5yqGHxIsLXpWL6ub9ydytEC5gmDp72itzKgrIdMWB+61IHCnbaUx+cAF7t8nzCddtRV0YpVG57LYaEmPBpe2nKcfJXK08PTZaCsELs2JFQVcFhstCbg0J1YUcFlstCTg0pxYUcBlsdGSgEtzYkUBl8VGSwIuzYkVBVwWGy0JuDQnVhRwWWy0JODSnFhRwGWx0ZKAS3NiRQGXxUZLAi7NiRUFXBYbLQm4NCdWFHBZbLQk4NKcWFHAZbHRkoBLc2JFAZfFRksCLs2JFQVcFhstCbg0J1YUcFlstKQBbr1eb3qeVx5+cINWAlGjBMzDMkEQtLTv+7uu624Vi0VIWRIIw1B1u9093Wg0ylEUHRQKhTXXvfvokaXXexZlTMf2ej3V6XSOHMfZ0GbVBjiO4+0oijbjOK48CwmBRWqtm47j7Gutd6rVausPaKYFzr0rt0cAAAAASUVORK5CYII='
            }
            return item
          })
          this.ImportantOrganizationValue.contentList = _data
        })
    },
    requestImportantCity () {
      importantCity(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAB1CAYAAAA7rH1RAAAABHNCSVQICAgIfAhkiAAABLlJREFUeF7t3W1u01gUBuBzHXDSlDb9pgSawlRFoIqRZgPsgn3wh1XwA/bBLtjASCDED9SEpE2mU8hA+JCTlNqjW1GpmjrJPXfyJsF6LVVU1bmv7cenrq8dGSMi0mg0ykmSPInj+FGSJDftz7joBYwxzSAIXhhjnlYqlZaxsHEcv8zn8zv5fF5yuZw+lSPOBE5PT6XX69mv/SAIHpp6vf4sDMPHxWKRRGMSiKLIAj83tVqtWSqVyuzYMcn+7OBOp9My1Wo1WV1dHV8yk84E2u22EBfUDMQFwbJzgbDEJS5YABjPcy5xgQLAaHYucYECwGh2LnGBAsBodi5xgQLAaHYucYECwGh2LnGBAsBodi5xgQLAaHYucYECwGh2LnGBAsBodi5xgQLAaHYucYECwGh2LnGBAsBodu6viHsax3LYPJZ/Pn+FbH4uCGRleUFubK6J/X4WF1jnvqseyrfvEXyf11ZLslXegK/HZwUQXNu1r97s+2yPeozt2t/3dtTjJjEAgms71nbupJY/HuxOalWq9RBXxaUrJq7OS1VNXBWXrpi4Oi9VNXFVXLpi4uq8VNXEVXHpiomr81JVE1fFpSueCu7mxopsrC873XDpn/yQ1tFH+TTkBtDFGVrU7UvnyzcnhSu5nCwuzkt49YpTvbZoKrja6eqo6fR5nr2n8eZtTey/mmV7a1NWlhY0Q5xqp4Kr3Zn6wdHQW5fnuKMOwiAR1M2fqeA6HXZF0f/Ftau6t7stc4VQsdbRpcT9abT72y25Nj83WkxRQVziDm+XcZwW2LkDjImrOFdpS4mrFVPUE/cC1uLCvFxfX3bmO2gdS7fbH1g/CPdWeSP18iotLzPnXPu0VvNZg1GTgzTc+WJB7u5spR6QtLzM4Gp35EO7I4etY1Xn2oO3d/9O6kFMy9Nuk8uv3dSuc+1syOUNfPbdiPZmzLBl2Dn3vxODQXmZwnU58q41/IPmKuVRR1wPNNchxHWV8qgjrgea6xDiukp51BH3AlqhEMrS4jVnxvanL3Jy8kN1nWuL7UywOJe/NC4tLzOXYtoZWufrd6m+b6lw7QG8v7udOiYtLzO4e/fuqJ64+uDaJ7p2PWlLpnHt1HQu5dd1UGtGUW/oE91B51wLHIZXL8Wm5WWmc51Pto6F/IPmCOVTRlwfNccxxHWE8ikjro+a4xjiOkL5lBHXR81xDHEdoXzKzj/YZx8F2Uc4PsvMX+f+9XdbPnz8rP4Ipw8GYoyd3KyvLcmN6+P5f4rG+gztz9fvEPs88Uzt54cHbeBYcd8fHA39BPjElTxWuLy0ILe3Nj1GXh4yVtyxbFGGQogLPJjEJS5QABjNziUuUAAYzc4lLlAAGM3OJS5QABjNziUuUAAYzc4lLlAAGM3OJS5QABjNziUuUAAYzc4lLlAAGM3OJS5QABjNziUuUAAYzc4lLlAAGM3OJS5QABjNziUuUAAYfda5tVqtWSqVyi7vnAFuS6ai7bt0Op1Oy9Tr9WdhGD4uFouZ2sFp7kwURdLr9Z6bRqNRjuP4ZaFQ2AlDt7cmTXPDZ3ndtmP7/b50u939IAgeGruxFjhJkidxHD9KkuTmLO/ALG+bMaYZBMELY8zTSqXS+hcHopXOeyELEgAAAABJRU5ErkJggg=='
            }
            return item
          })
          this.ImportantCityValue.contentList = _data
        })
    },
    changeCommon (val) { // 点击右侧卡片重新搜索
      let route = {
        path: '',
        params: {
          type: this.selectType,
          keyword: encodeURIComponent(val.name)
        }
      }
      route.path = `${this.createdPath()}/${route.params.type}/${true}/${route.params.keyword}`
      this.$router.push(route)
    },
    createdPath () {
      let path = '/searchType'
      if (this.$route && this.$route.path) {
        const index = this.$route.path.indexOf('searchType')
        if (index === -1) {
          path = this.$route.path + path
        } else {
          const snippet = this.$route.path.slice(0, index + 10)
          path = snippet
        }
      }
      return path
    },
    requestImportantCountry () {
      importantCountry(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,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'
            }
            return item
          })
          this.ImportantCountryValue.contentList = _data
        })
    },
    requestImportantIdustry () {
      importantIdustry(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAB1CAYAAAA7rH1RAAAABHNCSVQICAgIfAhkiAAABH1JREFUeF7t3F9u01gYBfDv3rROmk4nzBShKiUpEBV1BDMSG2AX7IMXVsED7INdsAGkGSoqqtQ4aaIKTWfIdJCTQK/R5xKJB2gc654mjo4lVInYx/bPp47/1DYiIp1Op54kyRPn3KMkSbb1/zjMLmCM6VlrXxhjnjabzb5RWOfcy3K53CqXy1IqlWZP5RSpwPn5uYxGI/3XttY+NFEUPQuC4HG1WiWRJ4E4jhX4uQnDsFer1epsrCfZrw0eDAZ9c3R0lGxubvpLZlIqcHp6KsQFlYG4IFg2FwhLXOKCBYDx3OcSFygAjGZziQsUAEazucQFCgCj2VziAgWA0WwucYECwGg2l7hAAWA0m0tcoAAwms0lLlAAGM3mEhcoAIxmc4kLFABGs7nEBQoAo9lc4gIFgNFs7rLjnjsnx7338v/HWMafPntZ3WB1RX5aX5Ob2zekZK2XzFlD5t5chd1/E4r+RAyKvHd3Zy7Ac8d91z2Rfz+cibVW6lvXZa0SeDGOh2Ppn/wtzjm5vlmTRv2Gl9xZQuaOu38QpruCncaW/HptY5ZlnzruPx/OJOqeyHq1Indbjanj+x5h7riv/jpM12n3zs10H+lz0H344dFxGvng912f0ZmyiJuJKd9IxM3nlmkq4mZiyjcSHFcPsYbD8Q+X7m27m36m3+Zra+V8a/GDqeJ4JN3++/TTy77QKpUAcqgGw9VDoeP+xYlBEYb0hEM3sKdDQV1nCK4eWh28jWAnBqiNpWdyesKhJx4+Bghu+11f/jv76GP5rjzj5411ad2qe5kvBPfP/XbhWjvR1Nbe27u9uLiTEwMvSziHEF8nHJDmEveiEcT9zm8GmwvcXRCXuEABYDSbS1ygADCazSUuUAAYzeYSFygAjF6K5v5xryXj8Wc5OIyAVCJ7uzsSBCuiF5SyDIXAnXaFf3J3YHI3IsuK5xkny3y+vWNSCFzE7fI8uFmmQdyGh164IS7gdYOTS456P+qyl28qvg6TP9zI0rA842SZj76aVe/76VCI3cI0iKv6QtM7C6WSXa4vtGm4i/r5UjSXuDkEeJvnAg16tJBjuyzEJNwtADcDcYkLFABGs7nEBQoAo9lc4gIFgNFsLnGBAsDohW7u64NQPnl6hhdo+N3o1dUVub/If587eeT0qmF8zO+Xaxtyq7HlIwpzbUHvR71+E6bP3RZp0OeP7/9229uTPZALNwqqwN2vj/kv+i5CdwX6NE/D8+sDYLhFaixqWYmLkkVdzwUub6Gi2Vzg5iIucYECwGg2l7hAAWA0m0tcoAAwms0lLlAAGM3mEhcoAIxmc4kLFABGs7nEBQoAo9lc4gIFgNFsLnGBAsBoNpe4QAFgNJtLXKAAMJrNJS5QABjN5hIXKACMTpsbhmGvVqvVL3vxBHAZljJaX44xGAz6JoqiZ0EQPK5Wq0u5ovNYqTiOZTQaPTedTqfunHtZqVRaQXD5q1PmsaBFmqc2djwey3A4bFtrHxpdeAVOkuSJc+5RkiTbRVqhRVpWY0zPWvvCGPO02Wz2vwAdTm+/T4SUPAAAAABJRU5ErkJggg=='
            }
            return item
          })
          this.ImportantIdustryValue.contentList = _data
        })
    },
    requestImportantFirm () {
      importantFirm(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,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'
            }
            return item
          })
          this.ImportantFirmValue.contentList = _data
        })
    },
    // requestGraph (id) {
    //   this.searchNode(id)
    //     .then((data) => {
    //       this.graphValue.graph = data
    //       return Promise.resolve()
    //     })
    //   // this.$pdAxios({
    //   //   method: 'post',
    //   //   url: '/country/tempGraphExplore',
    //   //   baseURL: config.baseUrl
    //   // })
    //   //   .then((data) => {
    //   //     if (data.data.errCode === 200) {
    //   //       this.graphTitle = this.entityMap[this.className] && this.entityMap[this.className].title
    //   //       this.graphValue.graph = data.data.data
    //   //     }
    //   //   })
    // },
    requestAllData (type = false, page = 1) {
      page === 1 && (this.loading = true)
      this.itemDetailValue.page = page
      let filters = _.cloneDeep(this.filters)
      let option = {}
      this.itemDetailValue.spaceLoadShow = true
      let allType = _.cloneDeep(searchMap.allSearchType)
      let aggs = searchMap.searchAggs
      if (this.selectType !== 'All') {
        let ite = _.find(searchMap.typeAgg, ['key', this.selectType])
        allType = [ite.id]
        ite.filter && filters.push(ite.filter)
        option = ite.option || {}
      }
      const arr = searchMap.searchList[this.selectType]
      aggs = _.filter(aggs, (item) => {
        return _.indexOf(arr, item.k.name) !== -1
      })
      if (this.$route.query.advanced === 'true') {
        // allType = [this.$route.query.select]
        let hightArr = JSON.parse(localStorage.getItem('advanceQuery'))
        hightArr = _.filter(hightArr, (item) => {
          if (item.column === 'published') {
            if (item.value) {
              let _filter = {
                d: '1',
                k: 'published',
                v: item.value
              }
              let index = _.findIndex(this.filters, (o) => o.k === _filter.k)
              if (index !== -1) {
                filters.splice(index, 1, _filter)
              } else {
                filters.push(_filter)
              }
            }
            return false
          }
          return item.column
        })
        _.forEach(hightArr, (item) => {
          if (item.column !== 'published') {
            if (item.type === 1 && item.column.indexOf('.smart') !== -1) {
              item.column = item.column.replace('.smart', '.keyword')
            }
            item.column = JSON.stringify([item.column])
          }
        })
        this.hightQueryBean = hightArr
      }
      let data = {
        docTypeList: allType,
        kw: this.keyWord,
        featureWeights: [],
        filters: filters,
        hieghtQueryBean: this.hightQueryBean,
        isExplain: false,
        pageNo: this.itemDetailValue.page,
        pageSize: this.itemDetailValue.size,
        templateId: '',
        current: 0,
        isAggs: 1,
        aggs: aggs,
        isRecovery: Boolean(this.isRecovery),
        token: this.searchToken,
        psn: 10005,
        ...option
      }
      // if (type) {
      //   data.isFilter = 1
      // } else if (this.$route.query.advanced === 'true') {
      //   data.isFilter = 0
      // }
      data.isFilter = 0
      if (this.sortField === 'published') {
        data.sortField = this.sortField
        data.sorts = this.sorts
      }
      if (this.sortField === '混合排序') {
        data.featureWeights = [
          {'k': '16', 'v': '2'},
          {'k': '19', 'v': '1'},
          {'k': '18', 'v': '1.3'},
          {'k': '17', 'v': '1.5'},
          {'k': '20', 'v': '2'}
        ]
        data.templateId = '3'
      }
      simplekw(data)
        .then((data) => {
          if (data.errCode === 200) {
            this.searchToken = data.data.token
            // if (!type) {
            _.forEach(data.data.tAggregationItem, (item) => {
              item.isShow = false
            })
            for (let item of data.data.tAggregationItem) {
              if (item && item.k && item.k.name === '时间') {
                item.v = _.reverse(_.sortBy(item.v, ['key']))
                for (let _item of item.v) {
                  // _item.value = this.timeTampToTime(_item.value)
                }
              }
              if (item && item.k.name) {
                item.k._name = searchMap.chinaToEnglish[item.k.name]
              }
            }
            this.selectValue = data.data.tAggregationItem
            // }
            this.hightQueryBean = []
            this.resultValue.keyWord = data.data.kw
            this.resultValue.result = data.data.recovery
            this.resultValue.rsCount = data.data.rsCount
            this.itemDetailValue.total = data.data.rsCount
            this.itemDetailValue.pageCount = _.ceil(this.itemDetailValue.total / this.itemDetailValue.size)
            if (this.itemDetailValue.page > 1) {
              this.itemDetailValue.content = _.concat(this.itemDetailValue.content, data.data.rsData)
            } else {
              this.itemDetailValue.content = data.data.rsData
            }
          } else if (data.message === 'token不合法') {
            this.itemDetailValue.page = this.itemDetailValue.page - 1
          } else {
            this.resultValue.keyWord = ''
            this.resultValue.result = ''
            this.resultValue.rsCount = 0
            this.itemDetailValue.total = 0
            this.itemDetailValue.pageCount = 0
            this.itemDetailValue.content = []
            this.selectValue = []
          }
          this.itemDetailValue.spaceLoadShow = false
          this.loading = false
        })
        .catch(() => {
          if (page === 1) {
            this.loading = false
            this.resultValue.keyWord = ''
            this.resultValue.result = ''
            this.resultValue.rsCount = 0
            this.itemDetailValue.total = 0
            this.itemDetailValue.pageCount = 0
            this.itemDetailValue.content = []
            this.itemDetailValue.spaceLoadShow = false
            this.selectValue = []
          }
        })
    },
    gotoCountry () { // 跳转到国家专题
      this.$router.push({name: this.graphRouterName})
    },
    sortList (val) { // 排序
      this.sortField = val
      this.sorts = '1'
      this.requestAllData(true)
    },
    selectItem (val) { // 选择左侧筛选导航
      this.filters = val
      this.requestAllData(true)
    },
    clearSelectItem () {
      this.$refs.navList.clearFilter()
      this.filters = []
    },
    requestImportantPeople () {
      importantPeople(this.entityType, this.entityName)
        .then((data) => {
          let _data = data.data.data.map((item) => {
            if (!item.img) {
              item.img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAB1CAYAAAA7rH1RAAAABHNCSVQICAgIfAhkiAAABQlJREFUeF7t3eFuElkYBuDvTO2AsHTa0tZKLVslNWuaNdkb8C68D/94Ff7Q+/AuvAGz2W1sbGAEBCsVcMriAC4z5sM2aVBCGc7HnO6+J/GPdt7CMy/HmTOnqSIiqlQquTAMnwZB8DgMwx3+O4zZBZRSNcuyXiqlnuXz+bpi2CAIXiUSiUIikaClpaXZU3HESGA4HFK/3+c/RcuyHqlyufzctu0nqVQKRJoEfN9n4BfKdd2a4zg5NFaT7HmDPc+rq1KpFGazWX3JSBoJNJtNAq5QGYArBIvmCsICF7jCAoLxmHOBKyggGI3mAldQQDAazQWuoIBgNJoLXEEBwWg0F7iCAoLRaC5wBQUEo9Fc4AoKCEajucAVFBCMRnOBKyggGI3mAldQQDAazQWuoIBgNJoLXEEBwWg09/+MOwwCOjvrUvtzh/xenwZf/x1x3Ezaox3wG+sOraykacmyBJmiRRvbXEZsnLao1e4QA08bm1mH7uS2pn3ZQv/dSNxPTY+q9cbMENzmVSdDmxurRjTZONzTpkfvI8BePhO/pG/S/r07M58c3QcYhctTweGRq+U9Mi4jxzmMwuWpgKcEHWN7a51u34r35zyMwj06LpPfG+iwpXQqSfcLu1qyooYYhfv6r+Oo7+OH44A7RgJcbd36MQi41wR3JZOmwl5O8NVOjzZqzv3zsEjBFe7Gpr8tIlwtjCm9LVap+6V3FbupXwPcMaJ31ZPRAo2OAVxBXHv5Bh38dlfHeYqcYcycq/PW90Ij7ltgY3D/6fp0XHofuSU/O/DeXo6cTFpr5ixhxuBKNBe4l6qg8yaCYzEtXML9+8ilr+ePcWb5+E362ocHhVgXzY2ZFhhI56UYFm7GKsfz7pu35bnv0paXb1Bhb2f0EDPOYVRzGYIfRlZrjcg3Ewz74P6vsU4HFyfUOFx+YR8+Numk0YpUurXVDO3tbkc6VvdB/zlcE257jW5u63OHytWTSEUC7hQ2fo7Gz9NmHZZljeZbXlcwYRg5LUS9LOMdN7zzxpRhLC4Dzbp4HvdNw/hJNRKXL8eOi9VIj9kx50753M6zpYl3Ox48uIvr3J8Zc2sP37hX2tk46RxtZB3aNWDHo3HTAq/p8truvCPu5UZ+/UbgnnW+b25m1IvNzfPi8vF8SeaspCm7vhrLOkNsuPzxb7c79PG0pRV00knhHY+8C51vjxc1Fo7Lzfxw8om8s+5c82pUIG7zrc11WlvLiP+ntzBc/sjzgoyO+TQq7OXj+KqCp4zb2xtid3TiuDyX8kdf19ZQHbDjGfwQc2tzTftmaTFcXjJsnLZj+ehHPQE8L/MttK5Fdu2489xdRUXReRxPF/uFXS3A2nFL7+rkdbo63+/Cs3T9wIp2XN2Pxxcue/4N//h9f+5vDdwJhMCdu1uTA4ALXEEBwWg0F7iCAoLRRjZX8P1eu2jtl2LXTkDwBQMXuIICgtFoLnAFBQSj0VzgCgoIRqO5wBUUEIxGc4ErKCAYjeYCV1BAMBrNBa6ggGA0mgtcQQHBaDQXuIICgtFoLnAFBQSj0VzgCgoIRqO5wBUUEIxGc4ErKCAYjeYCV1BAMHrUXNd1a47j5Pi3NGHoERgOh+R5Xl2Vy+Xntm0/SaVSepKRQr7vU7/ff6EqlUouCIJXyWSyYNvff88YRjQBbuxgMKBer1e0LOuR4hgGDsPwaRAEj8Mw3IkWjaOUUjXLsl4qpZ7l8/n6N2geb7+7PwqZAAAAAElFTkSuQmCC'
            }
            return item
          })
          this.ImportantPeopleValue.contentList = _data
        })
    },
    createdSelectValue () {
      let arr = [
        {
          name: '研报类型',
          isShow: false,
          children: [{
            name: '思路情报',
            value: 2387
          }, {
            name: '思路情报1',
            value: 237
          }, {
            name: '思路情报2',
            value: 237
          }, {
            name: '思路情报3',
            value: 2374
          }, {
            name: '思路情报4',
            value: 2377
          }, {
            name: '情报68',
            value: 237
          }, {
            name: '情报6878',
            value: 237
          }]
        },
        {
          name: '国家',
          isShow: false,
          children: [{
            name: '思路情报45',
            value: 2387
          }, {
            name: '思路情报14',
            value: 237
          }, {
            name: '思路情报2s',
            value: 237
          }, {
            name: '思路情报387',
            value: 2374
          }, {
            name: '思路情报49',
            value: 2377
          }]
        }
      ]
      if (this.$route.params.type !== 'report') {
        arr.splice(0, 1)
      }
      this.selectValue = arr
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../style/home.css";

    @media screen and (min-width: 768px) {
        .report-detail {
            height: calc(100vh - 69px) !important;
            overflow: hidden;
            padding-bottom: 18px !important;
        }
    }

    @media screen and (max-width: 992px) {
        .search-detail {
            width: calc(100% - 164px) !important;
        }
    }

    @media screen and (max-width: 767px) {
        .right-wrap {
            margin: 0 !important;
        }
        .search-detail {
            width: 100% !important;
        }

        .report-detail {
            height: calc(100vh - 65px - 72px) !important;
            overflow-y: auto;
        }

        .select-button {
            /*position: fixed;*/
            /*z-index: 9999;*/
            /*top: 10px;*/
            /*right: 10px;*/
        }

        .left-nav {
            width: 100% !important;
            height: 100% !important;
            padding: 10px 0;
        }

        .search-detail {
            margin-top: 10px;
        }

        .right-content {
            margin: 10px 0 0 0 !important;
        }
        /deep/ .the-data-card {
            .border-bottom {
                width: 100%;
                line-height: 35px !important;
            }
        }
    }

    @media screen and (max-width: 555px) {
        /deep/ .consulList {
            padding: 0 10px !important;
        }

        /deep/ .border-bottom {
            padding: 10px 0 !important;

            .title-text {
                width: 100% !important;
                max-width: 100% !important;
            }

            .tag-status {
                display: none;
            }

            img {
                /*width: 28% !important;*/
                object-fit: contain;
                margin-right: auto !important;
            }

            .media-have-img {
                width: 68% !important;
            }
        }
    }

    @media screen and (max-width: 1199px) {
        /deep/ .the-data-card {
            li {
                line-height: 22px !important;
            }

            .title-text {
                width: 120px !important;
            }
        }
    }

    .tab-chart-none {
        height: 42px !important;
        overflow: hidden;
    }

    .tab-chart {
        width: 96%;
        height: 273px;
        border-radius: 8px;
        border-bottom: 1px solid rgb(231, 231, 232);
        margin: 16px auto 5px;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
        /*background: #FAFBFE;*/

        .tab-chart-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px 0 0;
            font-weight: bolder;

            .tab-chart-type {
                color: #2C94FF;
                cursor: pointer
            }
        }
    }

    .tab-data-title {
        padding: 10px 20px;
        font-weight: bolder;
    }

    .report-detail {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 12px 10px 32px 16px;

        .left-nav {
            width: 177px;
            height: 100%;
            background: #ffffff;
            border-right: 1px solid #E7E7E8;
        }

        .tabs-classify-wrap {
            padding: 0 25px;
        }

        .common-tab-container {
            width: 100%;
            height: calc(100% - 105px);
            /*height: 100%;*/
            padding: 10px 10px 0 10px;

            /deep/ .title {
                top: 10px !important;
            }
        }

        .search-detail {
            width: calc(70% - 164px);
            height: 100%;
            background: #ffffff;
            display: flex;
            flex-direction: column;

            .search-head {
                width: 100%;
                min-height: 64px;
                padding: 0 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #E7E7E8;
            }

            .search-item {
                width: 100%;
                flex: 1;
                max-height: 100%;
                padding-bottom: 10px;
            }

            .tab-chart + .search-item {
                max-height: calc(100% - 64px - 273px - 21px);
            }

            .tab-chart-none + .search-item {
                max-height: calc(100% - 64px - 21px - 46px);
            }
        }

        .right-wrap {
            width: 100%;
            height: 100%;
            margin: 0 0 0 10px;
            display: flex !important;
            flex-direction: column;
        }

        .right-content {
            width: 30%;
            height: 100%;

            .list-wrap {
                flex: 1;
                background: #ffffff;
                /*margin-top: 10px;*/
                padding: 10px 20px;
            }

            .graph-wrap {
                width: 100%;
                height: 250px;
                margin-bottom: 10px;
                padding: 18px 28px;
                background: #ffffff;

                .graph-head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .graph-left {
                        display: flex;
                        align-items: center;
                    }

                    .title {
                        font-weight: bolder;
                        color: #303133;
                        font-size: 16px;
                    }

                    .change-text {
                        color: #208EFF;
                        cursor: pointer;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }
                }

                .container-wrap {
                    height: calc(100% - 30px);
                    cursor: pointer;
                    background: #ffffff;
                }
            }

            .common-card-wrap {
                height: auto;
                /*height: calc(40% - 10px);*/
            }

            .important-card {
                width: 100%;
                /*height: calc(33.333333333% - 10px);*/
                /*height: 130px;*/
                margin: 0 0 10px 0;
                padding: 16px 16px 6px 16px;
                background: #ffffff;
            }
        }
    }

    /deep/ .pdvis-node-legend {
        display: none;
    }

    /deep/ .the-data-card {
        height: calc(100% - 52px);
        font-size: 14px;

        ul {
            padding: 0 0 0 10px;

            li {
                padding: 0 5px 0 0;
                line-height: 35px;
            }

            .title-text {
                display: inline-block;
                width: 153px;
                flex: none;
            }

        }
    }
</style>
